const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'agent', label: 'From', sortable: false, thStyle: 'width: 10%' },
    { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: 'DateTime', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: 'Action', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: 'Changed Destination', sortable: false },
  ],
  KO : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'agent', label: 'From', sortable: false, thStyle: 'width: 10%' },
    { key: 'type', label: '타입', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: '시간', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: '행동', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: '변경 대상', sortable: false },
  ],
  JP: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'agent', label: 'From', sortable: false, thStyle: 'width: 10%' },
    { key: 'type', label: 'タイプ', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: '日付/時間', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: 'アクション', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: '変更された行き先', sortable: false },
  ]
}

const _i18n_error = {
  title : {
    EN: `Title is required`,
    KO: `Title is required`,
    JP: `タイトルは必須です`
  },
  content : {
    EN: `Content is required`,
    KO: `Content is required`,
    JP: `内容は必須です`
  }
}

const _i18n_data = {
  i18n_fields,
  _i18n_error
}

export default _i18n_data